const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  "1WBTC_1ETH": "0x39be7c95276954a6f7070f9baa38db2123691ed0",
  "1USDT_1ETH": "0x02f4d0021e3cb8736108e11c8df02fbbd6eeedbf",
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS["1WBTC_1ETH"]]: 10,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS["1USDT_1ETH"]]: 14
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS["1WBTC_1ETH"]]: 2,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS["1USDT_1ETH"]]: 2
};

module.exports = {
  ADDRESS: "0x67da5f2ffaddff067ab9d5f025f8810634d84287",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
